<template>
    <div :style="'background: whitesmoke;'">
        <div class="main-container">
            <div class="d-flex pt-2">
                <div v-if="cartProducts.length > 0" class="cursor-pointer" @mouseover="isHovered = true" @mouseleave="isHovered = false">
                    <div class="icon_hover">
                        <q-img @click="$router.go(-1)" :src="'/arrow.png'" @mouseover="isHovered = true"
                            @mouseleave="isHovered = false" :style="'width:25px; height: 25px'" />
                    </div>
                </div>
                <div v-if="cartProducts.length > 0" :style="'padding-top: 3px;'">
                    <span class="pt-0 pl-2 font-family text-bold" :style="'font-size: 22px;'">Your Cart</span>
                </div>
            </div>
            <div v-if="cartProducts.length == 0" class="mt-4" style="height: calc(100vh - 80px);">
                <div class="d-flex justify-center" :style="'margin-top: 12rem !important;'">
                    <h4>There is nothing in your bag. Let's add some items.</h4>
                </div>
                <div class="d-flex justify-center mt-4">
                    <q-btn @click="$router.push('/Partners/Stock/Products')" class="pd-btn mt-3" :style="'width: 200px;'">
                        ADD SOME PRODUCTS
                    </q-btn>
                </div>
            </div>
            <div v-if="cartProducts.length > 0" class="row mt-1">
                <div class="col-9 mb-1">
                    <q-scroll-area style="height: calc(100vh - 80px);">
                        <div :key="index" class="pt-0 px-4 mb-2" v-for="(product, index) in cartProducts">
                            <q-card class="mb-2 mt-1 cursor-pointer" :class="{ 'q-card-section--vert': false }" @click="openOrderDetail(product)">
                                <q-card-section :class="{ 'q-card-section--vert': false }" :style="'my-0'">
                                    <div class="row d-flex justify-between">
                                        <div class="col-2"
                                            :style="'height: 140px; width: 140px; position: relative; display: inline-block;'">
                                            <div class="col-2 image-container">
                                                <img :src="imageUrl(product.images)" @click="openOrderDetail(product)" class="cursor-pointer" />
                                            </div>
                                            <div v-if="product.tag?.toLowerCase() == 'most popular'" class="overlay-text">
                                                <span :style="'background-color: #F16565;'">Most Popular</span>
                                            </div>
                                        </div>
                                        <div class="col-9">
                                            <div class="ml-5 d-flex justify-between">
                                                <span class="text-bold"
                                                :style="'font-size: 18px; color: #105992; line-height: 40px;'"
                                                >{{product.name }}</span>
                                                <q-btn @click.stop="removeProduct(product.id)" icon="close" class="q-ml-auto" flat
                                                    size="small" />
                                            </div>
                                            <div class="mx-5 my-1 mr-5 pr-5 d-flex">
                                                <div>
                                                    <span  :style="'font-size: 15px; line-height: 1.5rem; color: #9e9e9e'"
                                                        class="text-grey text-bold">{{ product.productLineName }}
                                                    </span>
                                                </div>
                                                <div>
                                                    <span class="ml-5" :style="'color: #9e9e9e; font-size: 16px;'">
                                                        Rs. {{ getPriceData(product) }}/Unit
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="mr-5 mx-5 text-bold my-2" :style="'color: #388E3C; font-size: 14px;'">
                                                <span class="">You are saving {{ (product.mrp * product.quantity) -
                                                    (getPriceData(product) * product.quantity) | currencyFilter }}
                                                </span>
                                            </div>

                                            <div class="mx-5 d-flex">
                                                <div class="d-flex mt-2">
                                                    <div>
                                                        <span class="text-bold "  :style="'font-size: 20px; color: #044b9a'">
                                                            {{ Number(getPriceData(product) * product.quantity) |
                                                                currencyFilter }}
                                                        </span>
                                                    </div>
                                                    <div :style="'margin-top: 1px!important;'">
                                                        <span class="mrp-value ml-3 text-grey"
                                                        :style="'font-size: 17px; text-decoration: line-through; color: #9e9e9e'">
                                                            {{ Number(product.mrp) * product.quantity | currencyFilter
                                                            }}
                                                        </span>
                                                    </div>
                                                    <div class="mt-1">
                                                        <span class="text-price-value ml-3" :style="'font-size: 15px; color: #108f55;'">
                                                            {{ getPercentageData(product) }}% Off
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="d-flex ml-5">
                                                    <q-btn flat @click.stop="decreaseQuantity(product)" class="mr-3 pd-btn minus-btn"
                                                        :disabled="product.quantity == 1" icon="remove"/>
                                                    <div class="mr-3" :style="''">
                                                        <div class="">
                                                            <input v-model="product.quantity"
                                                                @input="handleInput(product, $event)" class="square"
                                                                @click.stop />
                                                        </div>
                                                    </div>
                                                    <q-btn flat @click.stop="increaseQuantity(product)"
                                                        :disabled="disableIncrementButton(product)" class="pd-btn plus-btn"
                                                        icon="add"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </q-card-section>
                            </q-card>
                        </div>

                        <div v-if="isLoading">
                            <div class="row justify-center q-my-md">
                                <q-spinner-dots color="primary" size="40px" />
                            </div>
                        </div>
                    </q-scroll-area>
                </div>
                <div class="col-3 px-2">
                    <q-card class="mb-3 mt-1 cart-summary-grid">
                        <div class="text-center p-3" :style="'background: #044b9a1a'">
                            <span class="text-bold font-family mt-2" :style="'font-size:22px; color: #044B9A'">Order Summary</span>
                        </div>
                        <q-card-section :style="'background: #044b9a1a'">
                            <div>
                                <div class="">
                                    <div class="d-flex mt-2 justify-between mx-2">
                                        <h6 class="font-family font-text-size">Order Total</h6>
                                        <h6 class="font-text-size" :style="'color: #167E85; font-size:18px'"> {{ (payableTotal + savingTotal) |
                                            currencyFilter }}</h6>
                                    </div>
                                    <q-separator class="my-2" />
                                    <div class="d-flex mt-2 justify-between mx-2">
                                        <h6 class="font-family font-text-size">Your Savings <span class="font-text-size text-bold"
                                            :style="'color: #388E3C;'">({{ savingPercentage }}%)</span>
                                        </h6>
                                        <h6 class="font-text-size" :style="'color: #167E85; font-size:18px'">{{ savingTotal | currencyFilter }}</h6>
                                    </div>
                                    <q-separator class="my-2" />
                                    <div class="d-flex mt-2 justify-between mx-2">
                                        <h6 class="font-family font-text-size">Order Amount</h6>
                                        <h6 class="font-text-size" :style="'color: #167E85; font-size:18px'">{{
                                            payableTotal |
                                            currencyFilter }}</h6>
                                    </div>
                                    <q-separator class="my-2" />
                                    <div v-if="gstColumn" class="d-flex mt-2 justify-between mx-2">
                                        <h6 class="font-family font-text-size">SGST Amount <span class="font-text-size">(9%)</span></h6>
                                        <h6 class="font-text-size" :style="'color: #167E85; font-size:18px'">{{
                                            gstCount('sgst') |
                                            currencyFilter }}</h6>
                                    </div>
                                    <div v-if="gstColumn" class="d-flex mt-2 justify-between mx-2">
                                        <h6 class="font-family font-text-size">CGST Amount <span class="font-text-size">(9%)</span></h6>
                                        <h6 class="font-text-size" :style="'color: #167E85; font-size:18px'">{{
                                            gstCount('cgst') |
                                            currencyFilter }}</h6>
                                    </div>
                                    <div v-if="!gstColumn" class="d-flex mt-2 justify-between mx-2">
                                        <h6 class="font-family font-text-size">IGST Amount <span class="font-text-size">(18%)</span></h6>
                                        <h6 class="font-text-size" :style="'color: #167E85; font-size:18px'">{{
                                            gstCount('igst') |
                                            currencyFilter }}</h6>
                                    </div>
                                    <q-separator class="my-2" />
                                    <div class="d-flex mt-2 justify-between mx-2">
                                        <h6 class="text-black font-text-size">Total Amount</h6>
                                        <h6 class="font-text-size" :style="'color: #167E85; font-size:18px'">{{ payableTotalAmount() |
                                        currencyFilter }}</h6>
                                    </div>
                                    <div class="d-flex mt-2 justify-between mx-2">
                                        <h6 class="text-black font-text-size">Rounded Amount</h6>
                                        <h6 class="font-text-size" :style="'color: #167E85; font-size:18px'">{{ sign() }} {{ roundedAmount() |
                                        currencyFilter }}</h6>
                                    </div>
                                    <q-separator class="my-2" />
                                    <div class="d-flex mt-2 justify-between mx-2">
                                        <h6 class="text-black text-bold font-text-size">Payable Amount</h6>
                                        <h6 class="font-text-size" :style="'-webkit-text-stroke-width: medium; color: #167E85; font-size:18px'">{{
                                            payableAmount() |
                                            currencyFilter }}</h6>
                                    </div>
                                    <q-separator class="my-2" />
                                    <div class="mx-4 mt-4 my-5 text-center">
                                        <span class="font-family text-bold text-grey" style="font-size: 13px">
                                            *Click on Checkout and complete email verification and payment process.
                                        </span>
                                    </div>
                                    <div class=" mt-3 text-center mx-2">
                                        <q-btn no-caps @click="$router.push('/Partners/Stock/PlaceOrder')"
                                            class="mt-3 view-cart" :style="'background-color: #105992'">
                                            <q-img :src="'/whiteBag.png'" :style="'width:20px; height: 20px;'" />
                                            <span class="ml-4 text-white text-bold"
                                                :style="'font-size: 18px; letter-spacing: 2px;'">
                                                Checkout
                                            </span>
                                        </q-btn>
                                    </div>
                                </div>
                            </div>
                        </q-card-section>
                    </q-card>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import axios from 'axios';
import _ from 'lodash';
import Constants from '../../Constants/Constant';
import { NetworkCommunicator, setHeader } from "../../plugins/NetworkResourceHandler";

export default {
    name: 'Products',

    data: function () {
        return {
            cartProducts: [],
            productsUpdatedData: [],
            organizationUserState: "",
            sgstAmount: 0,
            cgstAmount: 0,
            igstAmount: 0,
            cartData: [],
            allProducts: [],
            payableTotal: 0,
            savingTotal: 0,
            isHovered: false,
            savingPercentage: 0,
            user: JSON.parse(localStorage.getItem('user')),
            isLoading: false,
            page: 1,
            hasMoreData: true,
            createdmap: {
                success: 'success',
                created: 'Failed'
            }
        }
    },

    async created() {
        this.organizationUserState = this.user?.organization?.address?.state?.toLowerCase();
        setHeader()
        const apiUrl = Constants.api_url + 'getCurrentStock';
        // const request = {
        //     offset: (this.page - 1) * this.limit,
        //     limit: this.limit,
        // }
        const response = await NetworkCommunicator('GET', apiUrl);
        if (response) {
            this.allProducts = response.data;
        }
        const savedCart = localStorage.getItem('cartProducts');
        if (savedCart) {
            this.cartData = JSON.parse(savedCart);
        }
        this.calculateCartTotal((savedCart ? JSON.parse(savedCart) : []));
        this.loadData();
    },

    computed: {
        gstColumn () {
        if(this.organizationUserState == 'gujarat') {
            return true;
        } else {
            return false;
        }
        }
    },

    watch: {
        cartProducts: {
            handler(newVal) {
                this.cartProducts = newVal;
            }
        },
    },

    methods: {
        gstCount(type) {
            if(type == 'sgst' || type == 'cgst') {
                const count = (this.payableTotal * 9) / 100;
                this.sgstAmount = count;
                this.cgstAmount = count;
                return count;
            } else {
                const igstCount = (this.payableTotal * 18) / 100;
                this.igstAmount = igstCount;
                return igstCount;
            }
        },

        roundedAmount() {
            const difference = (this.payableAmount() - this.payableTotalAmount()).toFixed(2);
            const value = Math.abs(difference);
            return value;
        },

        sign() {
            const value = (this.payableAmount() - this.payableTotalAmount()).toFixed(2);
            if (value >= 0) {
                return '+';
            } else {
                return '-';
            }
        },

        payableTotalAmount() {
            if (this.organizationUserState == 'gujarat') {
                const sum = this.payableTotal + this.sgstAmount + this.cgstAmount;
                return sum;
            } else {
                const sum = this.payableTotal + this.igstAmount;
                return sum; 
            }
        },

        payableAmount() {
            if (this.organizationUserState == 'gujarat') {
                const sum = this.payableTotal + this.sgstAmount + this.cgstAmount;
                const value = this.roundedValue(sum);
                return value;
            } else {
                const sum = this.payableTotal + this.igstAmount;
                const value = this.roundedValue(sum);
                return value; 
            }
        },

        roundedValue(value) {
            if (value % 1 >= 0.5) {
                return Math.ceil(value);
            } else {
                return Math.floor(value);
            }
        },

        redirect() {
            this.$router.push(`/Partners/Stock/OrderSummary`)
        },

        removeProduct(id) {
            this.$q.dialog({
                title: 'Remove',
                message: 'Are you Sure, you want to Remove?',
                cancel: true,
                persistent: true,
            }).onOk(() => {
                const newArray = this.cartProducts.filter(item => item.id !== id);
                this.cartProducts = newArray;
                this.calculateCartTotal(newArray);
                localStorage.setItem('cartProducts', JSON.stringify(newArray));
                this.$q.notify({
                    position: 'top-right',
                    message: 'Product removed from the cart successfully!'
                });
            })
        },

        handleInput(product, event) {
            const inputedValue = event.target.value;
            let quantity = parseInt((product.quantity ? product.quantity : 1), 10);
            quantity = Math.min(Math.max(quantity, 1), product.maxPurchaseLimit);
            product.quantity = quantity;
            if (inputedValue > product.maxPurchaseLimit) {
                this.$q.notify({
                    position: 'top-right',
                    message: `You can buy maximum ${product.maxPurchaseLimit} quantities. Only ${product.maxPurchaseLimit} items left.`
                });
            }
            if (inputedValue == 0) {
                this.$q.notify({
                    position: 'top-right',
                    message: `You have to buy minimum 1 quantity or you can remove product from the cart.`
                });
            }

            const updatedProducts = this.cartProducts.map(item => {
                if (item.id === product.id) {
                    return { ...item, quantity: quantity };
                }
                return item;
            });
            this.cartProducts = updatedProducts;
            this.calculateCartTotal(updatedProducts);
            localStorage.setItem('cartProducts', JSON.stringify(updatedProducts));
        },

        calculateCartTotal(products) {
            const totalAmount = products.reduce((total, product) => {
                return total + this.calculateProductTotal(product);
            }, 0);
            this.payableTotal = totalAmount;

            const totalSavingAmount = products.reduce((total, product) => {
                return total + this.calculateProductSavingTotal(product);
            }, 0);
            this.savingTotal = totalSavingAmount;

            const savingPercentage = ((100 * Number(this.savingTotal)) / (Number(this.payableTotal) + Number(this.savingTotal)));
            this.savingPercentage = isNaN(savingPercentage) ? 0 : savingPercentage.toFixed(0);
        },

        calculateProductTotal(product) {
            const pricing = product.pricing.find(
                (price) => product.quantity >= price.qtyFrom && product.quantity <= price.qtyUpTo
            );

            if (pricing) {
                return Number(product.quantity) * Number(pricing.price);
            } else {
                const lowestPrice = product.pricing.reduce((minPrice, currentPrice) => {
                    const price = parseInt(currentPrice.price);
                    return price < minPrice ? price : minPrice;
                }, Infinity);
                const priceData = Number(lowestPrice) * Number(product.quantity);
                return priceData;
            }
        },

        calculateProductSavingTotal(product) {
            const savingTotal = (Number(product.mrp) * Number(product.quantity)) - (this.calculateProductTotal(product));
            return savingTotal;
        },

        imageUrl(image) {
            const url = Constants.base_url + image;
            return url;
        },

        openOrderDetail(product) {
            this.$router.push(`/Partners/Stock/ProductDetails/?productId=${product.id}`);
        },

        disableIncrementButton(product) {
            if (Number(product.quantity) >= Number(product.maxPurchaseLimit)) {
                return true;
            }
            return false;
        },

        decreaseQuantity(product) {
            if (Number(product.quantity)) {
                const updatedQuantity = Number(product.quantity) - 1
                const updatedProducts = this.cartProducts.map(item => {
                    if (item.id === product.id) {
                        return { ...item, quantity: updatedQuantity };
                    }
                    return item;
                });
                this.cartProducts = updatedProducts;
                this.calculateCartTotal(updatedProducts);
                localStorage.setItem('cartProducts', JSON.stringify(updatedProducts));
            }
        },

        increaseQuantity(product) {
            let updatedQuantity = 0;
            if (Number(product.quantity)) {
                updatedQuantity = Number(product.quantity) + 1;
            } else {
                updatedQuantity = 1;
            }

            const updatedProducts = this.cartProducts.map(item => {
                if (item.id === product.id) {
                    return { ...item, quantity: updatedQuantity };
                }
                return item;
            });
            this.cartProducts = updatedProducts;
            this.calculateCartTotal(updatedProducts);
            localStorage.setItem('cartProducts', JSON.stringify(updatedProducts));
        },

        getPriceData(product) {
            try {
                const pricingObject = product.pricing.find(pricing => {
                    const qtyFrom = parseInt(pricing.qtyFrom);
                    const qtyUpTo = parseInt(pricing.qtyUpTo);
                    return product.quantity >= qtyFrom && product.quantity <= qtyUpTo;
                });

                if (pricingObject) {
                    return pricingObject.price;
                } else {
                    const lowestPrice = product.pricing.reduce((minPrice, currentPrice) => {
                        const price = parseInt(currentPrice.price);
                        return price < minPrice ? price : minPrice;
                    }, Infinity)
                    return lowestPrice;
                }
            } catch (error) {
                console.error('Error fetching online products data', error);
            }
        },

        getPercentageData(product) {
            const price = this.getPriceData(product)
            const result = 100 - ((price * 100) / product.mrp);
            return result.toFixed(0);
        },

        loadData() {
            const savedCart = localStorage.getItem('cartProducts');
            this.cartProducts = savedCart ? JSON.parse(savedCart) : [];

            for (const cartProduct of this.cartProducts) {
                const correspondingItem = this.allProducts.find((item) => item.id == cartProduct.id);
                if (correspondingItem) {
                    cartProduct.stock = correspondingItem.stock;
                    cartProduct.maxPurchaseLimit = correspondingItem.maxPurchaseLimit;
                }
            }
        }
    }
}

</script>
  
<style scoped>

.overlay-text {
  position: absolute;
  bottom: 16px;
  left: 1px;
  background-color: #F16565;
  color: white;
  padding: 5px;
  font-size: 1em;
  border-radius: 1px;
  opacity: 90%;
}
.square {
  left: 3px;
  height: 27px;
  text-align: center;
  width: 25px;
  color: #167e85;
  border: none;
  outline: none;
  font-size: larger;
  margin-left: -5px;
  font-weight: bold;
  position: relative;
  margin-top: 3px;
}

.plus-btn{
  height: 35px;
  width: 34px;
  color: #1e1f3d80 !important;
  background-color: transparent !important;
  border: 1px solid #1e1f3d4d !important;
  border-radius: 5px;
  margin-left: 0px;
  font-size: larger;
}

.minus-btn{
  height: 35px;
  width: 34px;
  color: #1e1f3d80 !important;
  background-color: transparent !important;
  border: 1px solid #1e1f3d4d !important;
  border-radius: 5px;
  font-size: larger;
}

.icon-img-set {
    margin: 0 8px 0 22px;
}

.font-family {
    font-family: avenirRegular;
}

.font-text-size {
  font-size: 14px;
}

.icon_hover {
    height: 38px;
    width: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin-left: 18px
}

.icon_hover:hover {
    background-color: #EBEBEB;
}

.text-price-value {
    color: #167E85;
}

.product-image-size {
    width: 150px;
    max-width: 150px;
}

.image-container {
  height: 140px;
  width: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
  object-fit: cover;
  overflow: hidden;
  background: #E7EFF2 !important; 
}

.image-container img {
  max-width: 100%;
  max-height: 90%;
  object-fit: cover;
}

@media only screen and (max-width: 1100px) {
    .main-container {
        max-width: 980px;
        margin: 0 auto;
    }

    .main-image-set {
        margin-right: 25px;
    }

    .view-cart {
        height: 50px;
    }
}

@media only screen and (min-width: 1101px) and (max-width: 1280px) {
    .main-container {
        max-width: 1024px;
        margin: 0 auto;
    }

    .main-image-set {
        margin-right: 55px;
    }

    .view-cart {
        height: 50px;
    }
}

@media only screen and (min-width: 1281px) and (max-width: 1780px) {
    .main-container {
        max-width: 1240px;
        margin: 0 auto;
    }

    .main-image-set {
        margin-right: 75px;
    }

    .view-cart {
        height: 50px;
    }
}

@media only screen and (min-width: 1781px) {
    .main-container {
        max-width: 1440px;
        margin: 0 auto;
    }

    .main-image-set {
        margin-right: 90px;
    }

    .view-cart {
        height: 50px;
    }
}

.cart-summary-grid{
  position: sticky;
  top: 0;
  z-index: 1;
  box-shadow: none;
  border-radius: 15px;
}
</style>